import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import QuoteForm from '../../../components/base/QuoteForm';

const StoneCoatedGutterCapPage = () => {
  return (
    <div className="min-h-screen">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-12 sm:pb-16 lg:pb-20 bg-gradient-to-br from-teal-50 via-orange-50 to-amber-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
                Premium <strong>Stone Coated Gutter Cap</strong> in <strong>Northwest Arkansas</strong>
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                The ultimate <strong>gutter protection system</strong> for <strong>Fayetteville, Rogers, Bentonville, and Springdale</strong>. Beautiful, durable, and backed by a lifetime warranty.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all active:scale-95 touch-manipulation shadow-lg whitespace-nowrap min-h-[56px]">
                  <i className="ri-phone-line mr-2 text-xl"></i> Call (479) 337-7565
                </a>
                <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 border-2 border-teal-600 px-6 sm:px-8 py-4 sm:py-4 rounded-lg text-base sm:text-lg font-semibold hover:bg-teal-50 transition-all active:scale-95 touch-manipulation whitespace-nowrap min-h-[56px]">
                  Get Free Estimate
                </a>
              </div>
            </div>
            <div className="hidden lg:block">
              <img 
                src="https://public.readdy.ai/ai/img_res/c1b8b02937eead1e472c238bbb7ca5d5.jpg"
                alt="Stone coated gutter cap"
                className="w-full h-auto rounded-lg shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What Makes It Special */}
      <section className="py-12 sm:py-16 lg:py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Why Choose <strong>Stone Coated Gutter Cap</strong>?
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
              The most advanced <strong>gutter protection</strong> available in <strong>Northwest Arkansas</strong>
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-palette-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Beautiful Design</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Stone-coated finish matches your roof perfectly, enhancing your home's curb appeal instead of detracting from it.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-shield-check-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Lifetime Warranty</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Backed by a comprehensive lifetime warranty covering materials, performance, and installation.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-water-flash-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Superior Water Flow</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Advanced design handles even the heaviest Northwest Arkansas rainstorms while keeping debris out.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-hammer-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Durable Construction</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Heavy-gauge aluminum with stone coating resists rust, corrosion, and damage from extreme weather.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-leaf-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Blocks All Debris</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Keeps out leaves, pine needles, shingle grit, and even the smallest debris while allowing water through.
              </p>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-lg shadow-md p-6 sm:p-8 hover:shadow-lg transition-shadow border-l-4 border-teal-500">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6">
                <i className="ri-home-line text-2xl sm:text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Increases Home Value</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Premium protection that enhances your home's appearance and appeals to discerning buyers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Installation Process */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Professional Installation Process
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                1
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Free Inspection</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We assess your gutters, roof, and home to ensure proper fit and recommend the best color match.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                2
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Custom Fabrication</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Each gutter cap is custom-made to fit your home's exact specifications for perfect protection.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                3
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Expert Installation</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                Our certified installers secure the system properly to your roof and gutters for maximum performance.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 sm:p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold shadow-lg">
                4
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Quality Check</strong>
              </h3>
              <p className="text-base sm:text-base text-gray-600 leading-relaxed">
                We test the system, ensure proper water flow, and walk you through your lifetime warranty coverage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <QuoteForm 
              title="Free Project Estimate"
              subtitle="Get ready to hang up your ladder—professional installation with lifetime warranty"
            />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-br from-amber-50 to-orange-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Why Choose <strong>Stone Coated Gutter Caps</strong>?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className="ri-shield-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Blocks Leaves & Debris</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Advanced design keeps out leaves, pine needles, and debris while allowing maximum water flow. Never clean your gutters again.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className="ri-shield-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Long Lasting & Durable</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Stone coating provides exceptional hail resistance and durability. Engineered to withstand Arkansas weather for decades.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className="ri-shield-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Transferable Lifetime Warranty</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Our comprehensive lifetime warranty transfers to new homeowners, adding value to your property investment.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className="ri-shield-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Factory Direct & Made in USA</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Premium quality American-made products. Factory direct pricing ensures the best value for your investment.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className="ri-shield-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Seamless Roof Matching</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Stone coating blends perfectly with your existing roof, enhancing curb appeal rather than detracting from it.
              </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow border-t-4 border-teal-500">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className="ri-shield-star-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Prevents Ice Formation</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Superior design prevents ice dams and icicle formation during Arkansas winter weather, protecting your home year-round.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              How <strong>Stone Coated Gutter Caps</strong> Work
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 text-2xl font-bold shadow-lg">
                1
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Project Measurement</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Our local dealer will accurately measure your gutters, ensuring a perfect fit for optimal performance and protection throughout your Northwest Arkansas home.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 text-2xl font-bold shadow-lg">
                2
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Color Selection</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Choose from a variety of colors to match your home's exterior. Find the perfect shade for seamless integration and enhanced curb appeal.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 text-2xl font-bold shadow-lg">
                3
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Schedule Installation</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Arrange a convenient time for professional installation. Our expert team ensures a quick, hassle-free process, protecting your home efficiently.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 text-white rounded-full mx-auto mb-4 text-2xl font-bold shadow-lg">
                4
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                <strong>Hang Up the Ladder</strong>
              </h3>
              <p className="text-sm sm:text-base text-gray-600">
                Enjoy the freedom from gutter cleaning. With Stone Coated Gutter Cap installed, your gutters stay clear and debris-free, giving you peace of mind year-round.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-cyan-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Ready for Premium <strong>Stone Coated Gutter Caps</strong>?
            </h2>
            <p className="text-xl mb-8 text-teal-50">
              Contact <strong>NWA Gutter Guards</strong> today for a free estimate on <strong>stone coated gutter cap installation</strong> in <strong>Northwest Arkansas</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:479-337-7565" className="inline-flex items-center justify-center bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i> Call (479) 337-7565
              </a>
              <a href="/contact" className="inline-flex items-center justify-center bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-50 transition-all whitespace-nowrap">
                Request Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default StoneCoatedGutterCapPage;
